import { Link, Outlet, useLocation } from "react-router-dom";
import SiteNavbar from "@/components/feature/SiteNavbar";
import SiteFooter from "@/components/feature/SiteFooter";

const tabs = [
  { label: "首页", to: "/", match: "/", icon: "ri-home-5-line", activeIcon: "ri-home-5-fill" },
  { label: "分类", to: "/category/all", match: "/category", icon: "ri-apps-2-line", activeIcon: "ri-apps-2-fill" },
  { label: "搜索", to: "/search", match: "/search", icon: "ri-search-line", activeIcon: "ri-search-line" },
  { label: "专题", to: "/special/deep-space-dialogue", match: "/special", icon: "ri-fire-line", activeIcon: "ri-fire-fill" }
];

export default function SiteLayout() {
  const location = useLocation();

  const isActive = (match: string) =>
    match === "/"
      ? location.pathname === "/"
      : location.pathname.startsWith(match);

  return (
    <div className="flex min-h-screen flex-col bg-background-950">
      <SiteNavbar />
      <main className="flex-1 pb-20 lg:pb-0">
        <Outlet />
      </main>
      <SiteFooter />

      <nav
        className="fixed inset-x-0 bottom-0 z-40 flex items-center justify-around border-t border-background-800 bg-background-950/95 backdrop-blur-md lg:hidden"
        aria-label="底部快捷导航"
      >
        {tabs.map((tab) => {
          const active = isActive(tab.match);
          return (
            <Link
              key={tab.to}
              to={tab.to}
              className={`flex flex-1 cursor-pointer flex-col items-center gap-0.5 py-2.5 text-[11px] transition-colors ${
                active ? "text-accent-400" : "text-foreground-400"
              }`}
            >
              <span className="flex h-5 w-5 items-center justify-center">
                <i
                  className={`${active ? tab.activeIcon : tab.icon} text-lg`}
                  aria-hidden="true"
                />
              </span>
              {tab.label}
            </Link>
          );
        })}
      </nav>
    </div>
  );
}